<template>
    <div class="farm-list-table">
        <el-table :data="data" :empty-text="translate('no_data')">
            <el-table-column prop="territory_lyra_code" :label="translate('lyra_code')" />
            <el-table-column
                prop="volume"
                :label="translate('aggregated_volume')"
                :formatter="formatNumber"
            />
            <el-table-column prop="safraYear" :label="translate('safra')" />
            <el-table-column
                prop="analysis_date"
                :label="translate('last_analysis_date')"
            />
            <el-table-column
                :label="translate('actions')"
                width="100px"
                align="center"
            >
                <template class="" v-slot:default="scope">
                    <i
                        class="el-icon el-icon-view"
                        @click="handleView(scope.row)"
                    />
                </template>
            </el-table-column>
        </el-table>
        <dialog-eligibility-analysis
            v-if="dialogEligibilityVisible"
            :data="currentProperty"
            v-model="dialogEligibilityVisible"
        />
    </div>
</template>

<script>
import DialogEligibilityAnalysis from '@/modules/traceability-contract/views/components/dialog-eligibility-analysis/index.vue';
import formatters from '@/utils/formatters';
import TerritorioService from '@/services/TerritorioService';

export default {
    name: 'FarmListDefault',
    components: { DialogEligibilityAnalysis },
    props: {
        value: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            dialogEligibilityVisible: false,
            currentProperty: {}
        };
    },
    computed: {
        data: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        translate(key, params = {}) {
            const base = 'contrato_rastreabilidade.messages.view';
            return this.$t(`${base}.${key}`, params);
        },
        getLocale(locale, district = false) {
            const localeComplete = locale
                .split(' - ')
                .map(item => item.trim());
            return district ? localeComplete[0] : localeComplete[1];
        },
        async handleView(row) {
            let district = '--';
            let department = '--';
            await TerritorioService.findLocalidadeById(row.territory_id)
                .then(({data}) => {
                   district = this.getLocale(data, true);
                   department = this.getLocale(data, false);
                })
                .catch(() => {});
            this.currentProperty = {
                name: row.nome,
                department: department,
                district: district,
                area: row.area,
                ruc: row.ruc,
                eligibility: row.eligibility,
                producer_lyra_code: row.producer_lyra_code
            };
            this.dialogEligibilityVisible = true;
        },
        async handleRemove(row) {
            await this.$messageBox
                .confirm(
                    this.$tc(
                        'contrato_rastreabilidade.messages.modal_delete_selected_farm',
                        1
                    ),
                    this.$tc(
                        'contrato_rastreabilidade.messages.modal_delete_selected_farm_title',
                        1
                    ),
                    {
                        confirmButtonText: this.$t(
                            'contrato_rastreabilidade.words.confirm'
                        ),
                        cancelButtonText: this.$t(
                            'contrato_rastreabilidade.words.cancel'
                        )
                    }
                )
                .then(() => {
                    const index = this.data.findIndex(
                        item => item.id === row.id
                    );
                    this.data.splice(index, 1);
                })
                .catch(() => {});
        },
        handleDownload(row) {
            const file = new Blob([row.invoice_attachment], {
                type: row.invoice_attachment.type
            });
            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        },
        handleSelectionChange(selection) {
            this.$emit('update:selected', selection);
        },
        formatNumber(row, column, reportVolume, index) {
            return formatters.formatNumber(reportVolume);
        }
    }
};
</script>

<style scoped lang="scss">
.farm-list-table {
    .el-icon {
        display: flex;
        justify-content: center;
        cursor: pointer;
    }
}
</style>
